<script lang="ts" setup>
import EventVisit from '@/components/event/EventVisit.vue'
import ZoneList from '@/components/lists/ZoneList.vue'

const { params } = useRoute()
const { data: object } = useApi<components['schemas']['Event']>(
  `/ticketing/events/${params.slug}/`
)

const title = computed<string>(() =>
  object.value ? object.value.name : 'Cargando...'
)

const preparedMessageContent = computed<string | null>(() => {
  if (!object.value?.message_content) return null

  return object.value.message_content
    .replace(/&nbsp;/gi, ' ')
    .replace(/\u00A0/g, ' ')
})

useHead({
  title: () => title.value,
})

useSeoMeta({
  description: () => object.value?.description,
  fbAppId: '2007228622962747',
  ogTitle: () => object.value?.name,
  ogDescription: () => object.value?.description,
  ogImage: () => object.value?.image_portrait,
  ogType: 'website',
  ogUrl: () => `/events/${object.value?.slug}`,
  twitterTitle: () => object.value?.name,
  twitterDescription: () => object.value?.description,
  twitterImage: () => object.value?.image_portrait,
  twitterCard: 'summary',
})
</script>

<template>
  <div class="mx-0 lg:mx-20">
    <Image
      v-if="object?.image_hero"
      :src="object.image_hero"
      :alt="object.name"
    />

    <PageHeader>
      <PageTitle>
        {{ title }}
      </PageTitle>
    </PageHeader>

    <div
      v-if="object?.message_content && object?.message_level"
      class="mb-5 px-4"
    >
      <Message :severity="object.message_level">
        <div v-html="preparedMessageContent" />
      </Message>
    </div>

    <div class="gap-5 grid grid-cols-3 px-4">
      <div class="col-span-3 space-y-5 lg:col-span-2">
        <h3 class="text-surface-500">{{ object?.subtitle }}</h3>

        <Message severity="info">
          <i class="pi pi-calendar" /> Fecha:
          <strong>{{ formatDate(object?.date, 'PPPP') }}</strong
          ><br />
          <i class="pi pi-clock" /> Hora:
          <strong>{{ formatDate(object?.date, 'p') }}</strong
          ><br />
          <i class="pi pi-map-marker" /> {{ object?.place }}<br />
          <i class="pi pi-map" /> {{ object?.location.full_name }}
        </Message>

        <div>
          <h3>Acerca del evento</h3>

          <div class="prose">{{ object?.description }}</div>

          <ClientOnly><ShareLinks /></ClientOnly>
        </div>

        <ZoneList v-if="object" :event="object" title="Entradas" />
      </div>
      <div class="col-span-3 lg:col-span-1">
        <Image
          v-if="object?.image_map"
          :src="object.image_map"
          :alt="object?.name"
          preview
        />
      </div>
    </div>

    <ClientOnly>
      <EventVisit v-if="object" :event-id="object.id" />
    </ClientOnly>
  </div>
</template>
